module.exports = __webpack_public_path__ + "static/6305-woodrose-47-d1cb195ccde300446b916b4cdbe2f925.jpg";